<template>
	<BaseWebshopCouponForm v-slot="{onSubmit, onRemove, couponCode, message, error, loading, activeCoupon, handleInput}" :mode="props.mode">
		<div class="ww-coupons" :class="[{'ww-auth-coupons': mode == 'auth'}, {'ww-coupons-checkout': mode == 'checkout'}, {'base-coupon-error': error}, {'active': activeCoupon}, {'loading': loading}]">
			<BaseCmsLabel code="coupon_have_coupon" class="ww-coupons-label" tag="label" />

			<div v-if="activeCoupon" class="ww-coupons-active">
				<span class="ww-coupons-title" v-html="labels.get('coupon_included_code').replace('%COUPON_CODE%', '<strong>'+activeCoupon.code+'</strong>')"> </span>
				<span class="ww-coupon-delete" @click="onRemove"><BaseCmsLabel code="coupon_remove" tag="span" /></span>
			</div>

			<form v-else-if="(!activeCoupon || mode == 'auth')" class="ww-coupons-form" :class="mode == 'auth' && 'ww-auth-coupons-form'" @submit.prevent="onSubmit()">
				<div class="ww-coupons-add" :class="mode == 'auth' && 'ww-auth-coupons-add'">
					<input
						id="coupon_code"
						:placeholder="labels.get('coupon_enter_code')"
						type="text"
						:value="couponCode"
						name="coupon_code"
						@keyup="handleInput"
						class="ww-coupons-input"
						/>
					<button class="btn btn-primary ww-btn-add" type="submit"><BaseCmsLabel code="coupon_btn_add" tag="span" /></button>
					<BaseCmsLabel v-if="message" class="coupon_message" tag="div" :code="message" />
				</div>
			</form>

			<template v-if="mode != 'auth'">
				<BaseAuthCoupons v-if="auth.isLoggedIn()" v-slot="{items, onActivate, status}">
					<div v-if="!activeCoupon && items?.length" class="ww-coupons-list">
						<BaseCmsLabel code="coupon_available" class="ww-coupons-list-title" tag="h5" />
						<table class="ww-coupons-table">
							<tr :class="{'active': !activeCoupon}" v-for="item in items" :key="item.id">
								<td class="col-code">{{item.code}}</td>
								<td class="col-type">
									<span v-if="item.type == 'f'"><BaseUtilsFormatCurrency :price="item.coupon_price" /></span>
									<span v-else>-{{ item.coupon_percent * 100 }}%</span>
								</td>
								<td class="col-link">
									<span class="btn-coupon-add" @click="onActivate(item.code)"><BaseCmsLabel code="coupon_use" /></span>
								</td>
							</tr>
						</table>
					</div>
					<BaseCmsLabel v-if="status" class="coupon_message" tag="div" :code="status.label_name" />
				</BaseAuthCoupons>
			</template>
		</div>
	</BaseWebshopCouponForm>
</template>

<script setup>
	const props = defineProps(['mode']);
	const labels = useLabels();
	const auth = useAuth();
</script>

<style lang="less" scoped>
	.ww-coupons{
		&.active{
			.ww-coupons-form,.ww-coupons-list{display: none;}
			.ww-coupons-active{display: block;}
		}
	}
	.ww-coupons-active{
		.cart_info_total_extra_coupon_code{color: var(--primaryColor); font-weight: bold}
	}
	.ww-coupons-list-active,.ww-coupons-active{display: none;}

	.ww-coupons-form{display: flex; align-items: center;}
	.ww-coupons-label{padding-bottom: 0; padding-bottom: 15px; font-size: 24px; line-height: 32px; font-weight: 300;}
	.ww-coupons-add{
		position: relative; flex-grow: 1;
		input{width: 100%; height: 60px; padding: 0 125px 0 67px; font-size: 18px;}
		&:before{.icon-coupon; font: 18px/60px var(--fonti); color: var(--primaryColor); left: 25px; position: absolute; display: block; z-index: 9;}
	}
	.ww-btn-add{width: 110px; padding: 0; min-width: 110px; margin: 0; position: absolute; right: 0; top: 0; border-radius: 0 3px 3px 0 !important;}
	.coupon_message{position: absolute; bottom: -20px; color: var(--red); font-size: 14px; line-height: 18px; padding-left: 67px;}
	.ww-coupon-delete{
		font-size: 14px; text-transform: uppercase; font-weight: bold; position: relative; padding-left: 28px; color: var(--textColor);
		&:before{.icon-close; position: absolute; font: 12px/12px var(--fonti); color: var(--primaryColor); top: 3px; left: 10px; transition: var(--transition);  width: 12px; height: 12px; }
		@media(min-width: @h){
			&:hover{ text-decoration: underline;}
		}
	}
	.coupon_message_response_ok{color: var(--green);}
	.col-type{text-align: center; font-weight: bold;}
	.col-link{
		text-align: right;
		.btn-coupon-add,.btn-coupon-remove{text-transform: uppercase; font-weight: bold; font-size: 14px; text-underline-offset: 2px;
			@media(min-width: @h){
				&:hover{text-decoration: none; color: #472266;}
			}
		}
	}
	.ww-coupons-table{
		border-top: 1px solid var(--borderColor); width: 100%; 
		th{font-size: 14px; text-align: left; padding: 6px 0; border: 1px solid var(--white); padding: 10px 12px; background: var(--primaryColor); color: white;}
		td{font-size: 18px; padding: 2px 0 2px 0; line-height: 22px; font-weight: 300;}
		tr{border-top: 1px solid var(--borderColor); border-bottom: 1px solid var(--borderColor); margin-top: -1px; height: 54px;}
		tr:nth-child(even){background: white;}
		.col-code{width: 170px; color: var(--primaryColor); padding-right: 10px; font-weight: 400;}
		.col-description{width: 360px; padding-right: 10px;}
		.col-valid{text-align: right; text-align: right; padding-left: 10px;}
		.col-value{text-align: left;}
	}
	.ww-coupons-list{padding-top: 15px;}

	@media (max-width: @l){
		.ww-coupons-table{
			td{font-size: 16px;}
			.col-code{width: 155px;}
			.col-description{width: 380px;}
		}
	}

	@media (max-width: @t){
		.ww-coupons-label{font-size: 20px; line-height: 26px; padding-bottom: 10px;}
		.ww-btn-add{margin: 0; min-width: 100px; width: 100px; right: 0; top: 0; position: absolute; padding: 0 8px;}
		.ww-coupons-add{
			&:before{font: 16px/50px var(--fonti); left: 20px;}
			input{width: 100%; height: 50px; padding: 0 115px 0 56px; font-size: 16px;}
		}
		.ww-coupons-list{
			padding-top: 20px;
			.ww-coupons-list-title{padding-bottom: 3px;}
		}
		.ww-coupons-table{
			.col-code{width: 120px;}
			td{font-size: 14px;padding: 8px 0;}
			tr{height: 48px; min-height: 48px; padding: 0; margin: 0;}
			.col-description{width: 200px;}
		}
		.coupon_message{padding-left: 56px; font-size: 12px; line-height: 16px; bottom: -18px;}
		.ww-coupons-title{font-size: 18px; line-height: 24px;}
		.ww-coupons-form{flex-wrap: wrap;}
	}

	@media (max-width: @tp){
		.ww-coupons-table{
			.col-description{width: 370px;}
		}
	}
	@media (max-width: @m){
		.ww-coupons-label{font-size: 16px; line-height: 21px; padding-bottom: 10px; font-weight: bold;}
		.ww-coupons-add{
			&:before{left: 16px; font: 16px/50px var(--fonti);}
			input{height: 50px; width: 100%; padding: 0 110px 0 52px; font-size: 16px;}
		}
		.ww-btn-add{margin: 0; width: 110px; min-width: 110px; right: 3px; top: 3px; position: absolute; padding: 0 6px; font-size: 16px;}
		.coupon_message{padding-left: 49px;}
		.ww-coupons-title{font-size: 16px; line-height: 20px;}
		.ww-coupon-delete{font-size: 12px; padding-left: 23px;
			&:before{font: 10px/10px var(--fonti); top: 3px; left: 4px; width: 10px; height: 10px,;}
		}
		.ww-coupons-table{
			tr{padding: 6px 0; display: flex; flex-flow: column; min-height: unset; width: 100%; text-align: left; height: auto; border-top: 0;}
			td{padding: 4px 0; width: 100% !important; padding-right: 0 !important; padding-left: 0!important; font-size: 14px !important; line-height: 18px !important; text-align: left !important;}
		}
		.col-link{
			.btn-coupon-add,.btn-coupon-remove{font-size: 12px; line-height: 14px; text-underline-offset: 1px;}
		}
	}


	//checkout
	.ww-coupons-checkout{
		.ww-coupons-label{position: static; padding-bottom: 12px; font-size: 24px; line-height: 32px; font-weight: 300;}
		.ww-coupons-table{
			tr{padding: 10px 25px !important; height: 50px;}
			td{width: calc(~"100%/3");}
			.col-code{width: 120px; padding: 0;}
			.col-type{padding: 0;}
		}
		.ww-coupons-list-title{padding-bottom: 10px;}
		@media (max-width: @t){
			.ww-coupons-label{font-size: 22px; line-height: 28px; padding-bottom: 12px;}
		}
		@media (max-width: @tp){
			.ww-coupons-label{font-size: 16px; line-height: 22px; padding-bottom: 8px; display: block;}
		}
		@media (max-width: @m){
			.ww-btn-add{margin: 0 !important}
			.ww-coupons-table{
				tr{padding: 10px 0 !important; height: auto;}
				td{padding: 0;}
			}
		}
	}

	//AUTH
	.ww-auth-coupons{
		display: flex; align-items: center;
		@media (max-width: @t){flex-wrap: wrap;}
		h2{padding-bottom: 16px;}
		.ww-coupons-label{padding-bottom: 0; padding-right: 25px;}
		.ww-btn-add{width: 140px; min-width: 140px;}
		.ww-coupons-add input{padding: 0 160px 0 67px;}
		@media (max-width: @t){
			.ww-coupons-label{padding-right: 0; padding-bottom: 10px; font-size: 20px; line-height: 25px; width: 100%;}
			.ww-btn-add{min-width: 120px; width: 120px;}
			.ww-coupons-add input{padding: 0 140px 0 56px;}
		}
		@media (max-width: @m){
			.ww-coupons-label{font-size: 16px; line-height: 20px; padding-bottom: 8px;}
			.ww-coupons-add{
				input{padding: 0 105px 0 49px;}
			}
			.ww-btn-add{min-width: 90px; width: 90px;}
		}
	}
	.ww-auth-coupons-form{position: relative; flex-grow: 1;}
</style>